import * as React from 'react';
import config from "../../utils/config";
import Axios from "axios";
import HandleHTTPError from "../../utils/handleErrors";
import {Platform, StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import {Picker} from '@react-native-picker/picker';
import {SafeAreaView} from "react-native-safe-area-context";
import {FlatList} from "react-native-gesture-handler";
import {MaterialIcons} from "@expo/vector-icons";
import PreLoader from "../../components/PreLoader";

export default function CapexListComponent(props) {
    const {navigation} = props;
    const [working, setWorking] = React.useState(true);
    const [dataList, setDataList] = React.useState([]);
    const [refreshing, setRefreshing] = React.useState(false);
    const [next, setNext] = React.useState(null);
    const currentYear = new Date().getFullYear();
    const availableYears = Array.from({length: 10}, (_, i) => currentYear - i);
    const [selectedYear, setSelectedYear] = React.useState(currentYear);
    const [projectType, setProjectType] = React.useState("CAPEX");
    const [params, setParams] = React.useState({
        isActive: "True",
        ordering: "-createdAt",
        limit: 50,
        offset: 0,
        year: currentYear,
        is_auto: false,
    });

    React.useEffect(() => {
        getCapex();
    }, [params]);

    const getCapex = () => {
        const uri = `${config.api.host}projects/capex/history`;
        Axios.get(uri, {
            headers: config.api.headers,
            params,
        })
            .then(({data}) => {
                setRefreshing(false);
                setNext(data.next);
                setDataList(prev => [...prev, ...data.results]);
                setWorking(false);
            })
            .catch((error) => {
                setRefreshing(false);
                HandleHTTPError(error, navigation);
                setWorking(false);
            });
    };

    const renderListItem = (element) => {
        return (
            <TouchableOpacity
                style={styles.listItem}
                onPress={() => {
                    navigation.navigate("CapexUsageComponent", {
                        capex: element,
                    });
                }}
            >
                <View style={styles.listItemContent}>
                    <Text style={styles.itemTitle}>{element.name}</Text>
                    <Text style={styles.itemDescription}>{element.description}</Text>
                </View>
                <MaterialIcons name={'chevron-right'} size={24}/>
            </TouchableOpacity>
        );
    };

    const handleLoadMore = () => {
        if (!next || working || refreshing) {
            return;
        }
        setRefreshing(true)
        setParams({...params, offset: params.offset + params.limit});

    };

    if (working) {
        return <PreLoader/>;
    }

    return (
        <View style={styles.container}>
            <SafeAreaView style={styles.content}>
                <FlatList
                    data={dataList}
                    renderItem={({item}) => renderListItem(item)}
                    ListHeaderComponent={
                        <View style={styles.pickerRow}>
                            <View style={styles.pickerContainer}>
                                <Picker
                                    selectedValue={projectType}
                                    onValueChange={(value) => {
                                        setProjectType(value);
                                        setWorking(true)
                                        setDataList([])
                                        setParams({...params, is_auto: value === 'AUTO', offset: 0});
                                    }}
                                >
                                    <Picker.Item label="CAPEX" value="CAPEX"/>
                                    <Picker.Item label="AUTO" value="AUTO"/>
                                </Picker>
                            </View>
                            <View style={styles.pickerContainer}>
                                <Picker
                                    selectedValue={selectedYear}
                                    onValueChange={(value) => {
                                        setSelectedYear(value);
                                        setWorking(true)
                                        setDataList([])
                                        setParams({...params, year: value, offset: 0});
                                    }}
                                >
                                    {availableYears.map((year) => (
                                        <Picker.Item key={year} label={`${year}`} value={year}/>
                                    ))}
                                </Picker>
                            </View>
                        </View>
                    }
                    refreshing={refreshing}
                    ListEmptyComponent={
                        <View style={styles.emptyContainer}>
                            <Text>Sin elementos para mostrar</Text>
                        </View>
                    }
                    keyExtractor={(item) => item.id}
                    ListFooterComponent={
                        next && !working ? (
                            <View style={styles.loadMoreButtonContainer}>
                                <TouchableOpacity style={styles.loadMoreButton} onPress={handleLoadMore}>
                                    <Text style={styles.loadMoreText}>Cargar más</Text>
                                </TouchableOpacity>
                            </View>
                        ) : null
                    }
                />
            </SafeAreaView>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    content: {
        flex: 1,
        padding: 10,
        ...(Platform.OS === "web" && {
            width: "50%",
            alignSelf: "center",
        }),
    },
    listItem: {
        padding: 16,
        borderBottomWidth: 1,
        borderColor: '#ccc',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#fff'
    },
    listItemContent: {
        flexDirection: 'column',
    },
    itemTitle: {
        fontWeight: 'bold',
        fontSize: 16,
    },
    itemDescription: {
        fontSize: 14,
        color: '#666',
    },
    pickerRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 10,
    },
    pickerContainer: {
        backgroundColor: '#f0f0f0',
        borderRadius: 6,
        width: '48%',
    },
    emptyContainer: {
        alignItems: 'center',
        marginTop: 20,
    },
    loadMoreButtonContainer: {
        justifyContent: 'center',
        flexDirection: 'row'
    },
    loadMoreButton: {
        width: '50%',
        padding: 12,
        backgroundColor: '#007bff',
        borderRadius: 5,
        marginVertical: 10,
        alignItems: 'center',
    },
    loadMoreText: {
        color: '#fff',
        fontWeight: 'bold',
    },
});
